var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_18073",
    "data-name": "Grupo 18073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22.4,
    viewBox: "0 0 21 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M5,10.3a.7.7,0,0,1,.7-.7h7a.7.7,0,0,1,0,1.4h-7A.7.7,0,0,1,5,10.3ZM5,7.5a.7.7,0,0,1,.7-.7h7a.7.7,0,0,1,0,1.4h-7A.7.7,0,0,1,5,7.5ZM5,4.7A.7.7,0,0,1,5.7,4h7a.7.7,0,0,1,0,1.4h-7A.7.7,0,0,1,5,4.7Z",
    transform: "translate(2 1.6)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M3.8,0h14a2.8,2.8,0,0,1,2.8,2.8V19.6a2.8,2.8,0,0,1-2.8,2.8H3.8A2.8,2.8,0,0,1,1,19.6V18.2H2.4v1.4A1.4,1.4,0,0,0,3.8,21h14a1.4,1.4,0,0,0,1.4-1.4V2.8a1.4,1.4,0,0,0-1.4-1.4H3.8A1.4,1.4,0,0,0,2.4,2.8V4.2H1V2.8A2.8,2.8,0,0,1,3.8,0Z",
    transform: "translate(0.4)",
    fill: "#003082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M1.4,5.4V4.7a.7.7,0,1,1,1.4,0v.7h.7a.7.7,0,1,1,0,1.4H.7a.7.7,0,1,1,0-1.4Zm0,8.4v-.7a.7.7,0,1,1,1.4,0v.7h.7a.7.7,0,0,1,0,1.4H.7a.7.7,0,0,1,0-1.4Z",
    transform: "translate(0 1.6)",
    fill: "#003082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2304",
    "data-name": "Trazado 2304",
    d: "M5,33.414a.7.7,0,0,1,.7-.7H8.5a.7.7,0,1,1,0,1.4H5.7A.7.7,0,0,1,5,33.414Z",
    transform: "translate(2 -18.714)",
    fill: "#003082"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2305",
    "data-name": "Trazado 2305",
    d: "M1.4,19.757v-.7a.7.7,0,0,1,1.4,0v.7h.7a.7.7,0,1,1,0,1.4H.7a.7.7,0,1,1,0-1.4Z",
    transform: "translate(0 -8.557)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.a9ce33ec09b398646e54ba960ffb6442.svg";
export { ForwardRef as ReactComponent };